import React from 'react';
import { useSWRConfig } from "swr";
import { api, PortalContext } from '@portal/arq-portal-core';

export function Elemento(props: any): JSX.Element {
    
    const { elemento } = props;
    const { ciaGestiona } = React.useContext(PortalContext);
    const { mutate } = useSWRConfig();

    var urlParams = new URLSearchParams(window.location.search);
    var ciaUrl = urlParams.get('cia');
    let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;

    const likeElement = (event: any) => {
        event.stopPropagation();

        let jsonLike = {
            WallElementId: elemento.WallElementId,
            Title: elemento.User.UserName,
            Body: elemento.ShortBody,
            AllowComments: true,
            Type: "LIKE"
        };
    
        api.post('/be/piupointcreateordeletelike/', {"Entrada": {"json": JSON.stringify(jsonLike),"cia": cia}}).then(() => {
            mutate(["getwallelements"]);
        });
    };

    const deleteElement = (event: any) => {
        event.stopPropagation();

        let jsonLike = {
            ContentId: elemento.WallElementId
        };
    
        api.post('/be/piupointdeletewallelement/', {"Entrada": {"json": JSON.stringify(jsonLike),"cia": cia}}).then(() => {
            mutate(["getwallelements"]);
        });
    };


    const getTimeDiff = (CreationDate: string) => {

        let today = new Date();
        let created = new Date(CreationDate + 'Z');
        let hours = 0;
        let minutes = 0;
        let days = 0;
        let month = 0;
        let years = 0;

        const timeDiff = today.getTime() - created.getTime();
        minutes = Math.floor(timeDiff / (1000 * 60));
        hours = Math.floor(timeDiff / (1000 * 60 * 60));
        days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        month = (today.getMonth() + 1) - (created.getMonth() + 1) + (12 * (today.getFullYear() - created.getFullYear()));
        years = today.getFullYear() - created.getFullYear();

        if (minutes < 60) {
            return ` ${minutes === 1 ? 'un' : `${minutes}`} minuto${minutes === 1 ? '' : 's'}`;
        } else if (hours < 24) {
            return ` ${hours === 1 ? 'una' : `${hours}`} hora${hours === 1 ? '' : 's'}`;
        } else if (days < 30) {
            return ` ${days === 1 ? 'un' : `${days}`} día${days === 1 ? '' : 's'}`;
        } else if (month < 12) {
            return ` ${month === 1 ? 'un' : `${month}`} mes${month === 1 ? '' : 'es'}`;
        } else {
            return ` ${years === 1 ? 'un' : `${years}`} año${years === 1 ? '' : 's'}`;
        }
    }

    return (
        <div className="elementoReducido">
            <div className="elemHeader">
                <div className="time">hace 
                    {getTimeDiff(elemento?.CreationDate)}
                </div>
                <div className="actions">
                    <div className="iconLikeCont">
                        <i onClick={likeElement} className={`icon-pro-like ${!elemento?.CanLike ? `is-liked` : ``}`}></i>
                        <span className="inline">({elemento?.Likes.length})</span>
                    </div>

                    {elemento?.CanComment && 
                        <div className="likeDiv">
                            <i className="icon-chat"></i>
                            <span className="inline">
                                ({elemento?.WallCommentsCount})
                            </span>
                        </div>
                    }
                    {elemento?.CanDelete && <i className="icon-papelera" onClick={deleteElement}></i>}
                </div>
            </div>

            <div className="content">
                <div className="comment">
                    {elemento?.ShortBody}
                </div>
                <div className="user">Publicado por <span>{elemento?.User.UserName} ({elemento?.User.JobTitle})</span></div>
            </div>
        </div>
    )
}